import axios from "axios";

// Generalized function for fetching PackageManagement
function fetchPackageManagementData(endpoint) {
  return axios.get(`/admin/package-management/${endpoint}`);
}

// Specific functions using the generalized PackageManagement function

export function fetchPackageManagementDataByPartners() {
  return fetchPackageManagementData("list-packages-by-client-type");
}
export function fetchPackageManagementDataByCategories() {
  return fetchPackageManagementData("list-packages-by-category");
}
